import React from 'react';
import { Zap } from 'lucide-react';
import logoUrl from '../assets/bangla_aj_logo.png';

export const Header = () => (
    <header className="bg-gradient-to-r from-slate-900/80 via-slate-800/80 to-slate-900/80 backdrop-blur-xl shadow-2xl sticky top-0 z-20 border-b border-teal-500/10">
      <div className="container mx-auto px-4 py-3 flex items-center justify-between">
        {/* LEFT: Logo + Tagline */}
        <div className="flex items-center space-x-4">
          <div className="flex flex-col items-start">
            {/* Logo: transparent PNG or SVG is ideal so it blends with header */}
            <img
              src={logoUrl}
              alt="বাংলাআজ"
              className="h-12 sm:h-14 w-auto object-contain bg-transparent"
              style={{ imageRendering: "optimizeQuality" }}
            />

            {/* Tagline: hidden on very small screens to preserve space */}
            <p className="mt-1 text-xs sm:text-sm text-gray-300/90 hidden xs:block">
              সর্বশেষ সংবাদ আপনার হাতের মুঠোয়
            </p>
          </div>
        </div>

        {/* RIGHT: Live badge */}
        <div className="flex items-center space-x-3">
          <div className="flex items-center text-sm text-gray-100 space-x-2 bg-teal-500/10 px-4 py-2 rounded-full border border-teal-500/20">
            <Zap className="w-4 h-4 text-yellow-400 animate-pulse" />
            <span className="font-medium">লাইভ আপডেট</span>
          </div>
        </div>
      </div>
    </header>
  );
